var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import Autocomplete from "../Autocomplete/Autocomplete";
import { useClient } from "../../hooks/client";
import { useMemo } from "react";
export var useKeyedOptions = function (useOptions, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
additions) {
    return function (key) {
        return function () {
            var _a, _b;
            var client = useClient();
            var response = useOptions(__assign({ clientId: client.clientId || "" }, (additions || {})), { shouldSkipCall: function () { return !client.clientId; } });
            return ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[key]) || [];
        };
    };
};
export var updateSelector = function (selections, setSelections) {
    return function (name) { return ({
        setValues: function (value) {
            setSelections(function (previous) {
                var _a;
                return (__assign(__assign({}, previous), (_a = {}, _a[name] = value || [], _a)));
            });
        },
        values: (selections === null || selections === void 0 ? void 0 : selections[name]) || [],
    }); };
};
export var HidingOptionlessComponent = function (_a) {
    var useOptions = _a.useOptions, children = _a.children;
    var options = useOptions();
    if (!(options === null || options === void 0 ? void 0 : options.length)) {
        return _jsx(_Fragment, {});
    }
    return _jsx(_Fragment, { children: children });
};
export var AutoCompleteFilter = function (_a) {
    var useOptions = _a.useOptions, label = _a.label, description = _a.description, selector = _a.selector, disabled = _a.disabled;
    var options = useOptions();
    return useMemo(function () { return (_jsx(Autocomplete, { onSelect: function (value) {
            selector.setValues(value);
        }, description: description, label: label, options: options, initialValue: selector.values, disabled: !!disabled })); }, [JSON.stringify(options), disabled]);
};
